export default {
  isAuthorized(state) {
    return state.accessToken.length > 0; // && !!state.me;
  },
  meInfo(state) {
    return state.me;
  },
  isUserInfo(state) {
    return state.mPatient.userInfo;
  },
  isDev() {
    return process.env.NODE_ENV === "development";
  },
  isCertifyCard(state) {
    return state.certifyCard.length > 0;
  }
};

